const setUserPermissions = (state, { role, id, orgs, editableProperties, viewableProperties }) => {
  state.currentUser = { role, id, orgs }
  state.userEditableProperties = editableProperties
  state.userViewableProperties = viewableProperties
}

export default {
  setUserPermissions,
}
